import app from './app';

const token = {
  check: (jwt) => {
    if (jwt.exp < Math.floor(Date.now() / 1000)) {
      return false;
    }

    return true;
  },

  get: async () => {
    const response = await fetch('/api/token');
    const json = await response.json();
    const jwt = json._token;

    return jwt;
  },

  parse: (jwt) => {
    const base64Url = jwt.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));

    return JSON.parse(jsonPayload);
  },

  run: async () => {
    let fetchedJWT = null;
    let storedJWT = localStorage.getItem('token');

    if (storedJWT === 'undefined') {
      storedJWT = false;
    }

    if (!storedJWT) {
      fetchedJWT = await token.get();
      token.set(fetchedJWT);
    } else if (!token.check(token.parse(storedJWT))) {
      fetchedJWT = await token.get();
      token.set(fetchedJWT);
    } else {
      token.set(storedJWT);
    }

    /*
    const lifetimeText = document.getElementById('app-token-lifetime');
    const liefeTimeInterval = setInterval(() => {
      const exp = token.parse(app.run.token).exp;
      const now = Math.floor(Date.now() / 1000);

      const diff = exp - now;

      lifetimeText.innerHTML = `Token will expire in ${diff} seconds`;

      if (diff === 0 || diff < 0) {
        clearInterval(liefeTimeInterval);
        lifetimeText.innerHTML = 'Token has expired!';
        window.location = '/?token-expired';
      }
    }, 1000);
    */
  },

  set: (jwt) => {
    app.run.headers = {
      'Authorization': `Bearer ${jwt}`,
    };
    app.run.token = jwt;

    localStorage.setItem('token', jwt);
  },
};

export default token;
